<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<button @click="$refs.create.open()" class="btn btn-success">
					Nuevo grupo
				</button>
			</div>
		</div>
		<div v-if="groups" class="row">
			<div v-if="groups.length" class="col-md-12">
				<hr>
				<div class="btn-toolbar" role="toolbar">
					<div v-for="group in groups" class="btn-group" role="group">
						<button @click="$refs.edit.open(group)" class="btn btn-default btn-lg">
							{{ group.name }}
						</button>
						<button @click="destroy(group)" class="btn btn-danger btn-lg">
							<i class="fa fa-trash" aria-hidden="true"></i>
						</button>
					</div>
				</div>
			</div>
		</div>

		<template v-if="product">
			<create
				@reload="reload"
				ref="create"
				:user="user"
				:isAuth="isAuth"
				:product="product">
			</create>

			<edit
				@reload="reload"
				ref="edit"
				:user="user"
				:isAuth="isAuth"
				:product="product">
			</edit>
		</template>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Create from './../views/Create.vue'
	import Edit from './../views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'product'],
		components: {
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				groups: null,
			}
		},
		created() {
			this.init();
		},
		methods: {
			init() {
				this.getData();
			},
			getData() {
				this.$http.get('admin/management/products/' + this.product.id + '/groups')
					.then(response => {
						this.groups = response.body
					})
			},
			reload() {
				this.getData()
				this.$emit('reload')
			},
			destroy (group) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/groups/' + group.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/components/groups/layout/Groups.vue